module.exports = __webpack_public_path__ + "img/source_sans+source_serif.b22712d1.png";